import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT ?? "development";

if (dsn) {
  Sentry.init({
    dsn,
    environment,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    release: import.meta.env.VITE_APP_VERSION,
    sendDefaultPii: false,
    beforeSend(event): Sentry.ErrorEvent | null {
      if (event.request) {
        delete event.request.data;
        delete event.request.cookies;
        delete event.request.headers;
      }
      if (event.breadcrumbs && Array.isArray(event.breadcrumbs)) {
        event.breadcrumbs = event.breadcrumbs.filter(
          (b) => b.category !== "ui.input"
        );
      }
      if (event.extra) {
        const safeKeys = new Set(["route", "component", "release"]);
        event.extra = Object.fromEntries(
          Object.entries(event.extra).filter(([k]) => safeKeys.has(k))
        );
      }
      return event;
    },
    enabled: environment !== "development",
  });
}

createRoot(document.getElementById("root")!).render(<App />);
